package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.Pomodoro_check
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class PomodoroCheckRepository(private val db: TeddDatabase) {

    fun observeByItem(itemId: String): Flow<List<Pomodoro_check>> =
        db.pomodoroCheckQueries.selectByItem(itemId).asFlow().mapToList(Dispatchers.Default)

    suspend fun create(
        itemId: String,
        label: String,
        note: String? = null,
        orderIndex: Long = 0,
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        val id = newId("pc")
        db.pomodoroCheckQueries.insert(id, itemId, label, note, 0L, orderIndex, now, now)
        id
    }

    suspend fun setChecked(id: String, checked: Boolean) = withContext(Dispatchers.Default) {
        db.pomodoroCheckQueries.updateChecked(if (checked) 1L else 0L, nowMillis(), id)
    }

    suspend fun updateLabel(id: String, label: String, note: String?) = withContext(Dispatchers.Default) {
        db.pomodoroCheckQueries.updateLabel(label, note, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.pomodoroCheckQueries.softDelete(now, now, id)
    }
}
